import React from 'react';
export function SmartWireSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center space-y-8" data-id="element-4441">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5]" data-id="element-4442">
        Discover the Power of Smart Wire for your Wire EDM
      </h2>
      <p className="text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-4443">
        <strong data-id="element-4444">
          SMART wire spools are equipped with radio frequency identification
          (RFID) chips
        </strong>{' '}
        to store wire characteristics and traceability-related data. You avoid
        unexpected interruptions by monitoring the wire length remaining and you
        always use the correct wire because SMART wire checks the wire
        technology selected on the machine.
      </p>

      <div className="max-w-3xl mx-auto aspect-video rounded-xl overflow-hidden shadow-lg" data-id="element-4445">
        <iframe className="w-full h-full" src="https://www.youtube.com/embed/a4Wjo7-G1SU?wmode=opaque" title="SMART Wire Video" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-4446"></iframe>
      </div>

      <div data-id="element-4447">
        <a href="https://www.peakedm.com/uploaded/files/EDM%20Consumables%20-%20smart-wires-en.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-block text-orange font-bold text-lg underline hover:text-orange/80 transition-colors" data-id="element-4448">
          SMART Wire Flyer
        </a>
      </div>
    </div>;
}